import * as z from "zod";
import {
  hsaReconciliationPageInputSchema,
  hsaReconciliationPaginationSchema,
} from "./hsa-reconciliation-common";

/** One row of Gale's Payouts table: a bank transfer of settled funds. */
export const hsaPayoutSchema = z.object({
  payoutId: z.string(),
  /** `payout` | `payout_return`; a return carries a positive amount too. */
  type: z.string(),
  /** `booked` as Gale sends it; the dashboard renders that as "Paid". */
  status: z.string(),
  amountCents: z.number().int(),
  currency: z.string(),
  /** `YYYY-MM-DD` the funds were paid out — the date to display. */
  valueDate: z.string().nullable(),
  /** Only a labelled fallback while `valueDate` is null. */
  creationDate: z.string().nullable(),
  estimatedArrivalDate: z.string().nullable(),
  /** When Gale's daily report confirmed the payout; null while only the
   * webhook has been seen, which is when the breakdown is still on its way. */
  reportConfirmedAt: z.string().nullable(),
});
export type HsaPayout = z.infer<typeof hsaPayoutSchema>;

/** Gale's payouts for the authenticated team. Same beta gate as
 * `getHsaTransactions`. */
export const getHsaPayouts = {
  name: "getHsaPayouts" as const,
  input: hsaReconciliationPageInputSchema.extend({
    /** Gale rejects fewer than 2 characters. */
    search: z.string().min(2).optional(),
    /** Adyen status as Gale stores it (`booked`, `pending`, …). */
    status: z.string().min(1).optional(),
  }),
  output: z.object({
    payouts: z.array(hsaPayoutSchema),
    pagination: hsaReconciliationPaginationSchema,
  }),
};
